import {
  CLEAR_CURRENT_CHANNEL,
  SET_CURRENT_CHANNEL,
  SET_CURRENT_CHANNEL_FOLLOWERS,
  SET_DASHBOARD_CONTEXT,
} from 'actions';

import { PERSONAL_CONTEXT_TYPE } from 'actions/context/ContextTypes';
import DashboardContext from 'actions/context/DashboardContext';

const defaultState = {
  ctx: new DashboardContext({ type: PERSONAL_CONTEXT_TYPE }),
  channel: {},
};

export function context(state = defaultState, action = null) {
  switch (action.type) {
    case SET_DASHBOARD_CONTEXT: {
      return { ...state, ctx: action.ctx };
    }
    case CLEAR_CURRENT_CHANNEL: {
      return { ...state, channel: {} };
    }
    case SET_CURRENT_CHANNEL: {
      return {
        ...state,
        channel: {
          ...state.channel,
          ...action.channel,
          idToFollowerMap: Object.assign(
            {},
            ...action.channel.followers.map(f => ({ [f.id]: f }))
          ),
        },
      };
    }
    case SET_CURRENT_CHANNEL_FOLLOWERS: {
      return {
        ...state,
        channel: {
          ...state.channel,
          followers: action.followers,
          idToFollowerMap: Object.assign(
            {},
            ...action.followers.map(f => ({ [f.id]: f }))
          ),
        },
      };
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./app/reducers/context.js